import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { map } from 'rxjs/operators';
import {Observable, of, Subject, throwError} from "rxjs";
import { StorageMethod } from './enumes/storage-method';
import {StorageSecretKey} from "./enumes/storage-secret-key";
import { StorageAppKey } from './enumes/storage-app-key';
// import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storageSub= new Subject();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  read<T>(key: StorageAppKey, isValid:(x: unknown) => x is T): T | null {
    let raw: string | null;
    try {
      raw = sessionStorage.getItem(key);
    } catch {
      return null;
    }
    if (raw === null) {
      return null;
    }
    try {
      const parsed: unknown = JSON.parse(raw);
      return isValid(parsed) ? parsed : null;   
    } catch {
     return null; 
    }
  }

  public wipe(): Observable<void> {
        return this.invokeStorage(StorageMethod.WIPE);
    }

    public getKeys(): Observable<Array<string>> {
        return this.invokeStorage(StorageMethod.KEYS);
    }

    public set(key: string, value: any): Observable<any> {
        this.storageSub.next('added');
        return this.invokeStorage(StorageMethod.SET, key, value);
    }

    public get(key: any): Observable<any> {
        this.storageSub.next('got');
        return this.invokeStorage(StorageMethod.GET, key);
    }

    public remove(key: string): Observable<any> {
        this.storageSub.next('removed');
        return this.invokeStorage(StorageMethod.REMOVE, key);
    }

  public setSecureStorage(key: string, value: string) {
    return this.invokeStorage(StorageMethod.SEC_SET, key, value);
  }

  public getSecureStorage(key: string) {
    return this.invokeStorage(StorageMethod.SEC_GET, key);
  }

  public watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

    private invokeStorage(type: StorageMethod, key?: string, value?: string): Observable<any> {
                switch (type) {
                    case StorageMethod.GET:
                        return of(sessionStorage.getItem(<string>key)).pipe(
                            map((response) => JSON.parse(response as string))
                        );
                    case StorageMethod.SET:
                        value = JSON.stringify(value);
                        return of(sessionStorage.setItem(<string>key, value));

                    case StorageMethod.REMOVE:
                        return of(sessionStorage.removeItem(<string>key));

                    case StorageMethod.KEYS:
                        return of(sessionStorage).pipe(
                            map((ls: any) => {
                                const keys: Array<string> = [];

                                for (let i = 0; i < ls.length; i++) {
                                    keys.push(ls.key(i));
                                }

                                return keys;
                            })
                        );

                    case StorageMethod.WIPE:
                        return of(sessionStorage.clear());

                    // case StorageMethod.SEC_SET:
                    //   value = JSON.stringify(value);
                    //   return of(sessionStorage.setItem(<string>key, this.encrypt(value)));

                    // case StorageMethod.SEC_GET:
                    //   return of(sessionStorage.getItem(<string>key)).pipe(
                    //     map((response) => JSON.parse(this.decrypt(response)))
                    //   );

                    default:
                        const err = new Error(`Unknown request type for storage.`);
                        return throwError(() => err);
                }
    }

  // private encrypt(txt: any): string {
  //   return CryptoJS.AES.encrypt(txt, StorageSecretKey.KEY).toString();
  // }

  // private decrypt(txtToDecrypt: any): string {
  //   return CryptoJS.AES.decrypt(txtToDecrypt, StorageSecretKey.KEY).toString(CryptoJS.enc.Utf8);
  // }
}
